import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createProduct } from "api/product.api";
import { invalidateProductSide } from "lib/cacheInvalidation";

export const useCreateProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createProduct,
    onSuccess: () => {
      invalidateProductSide(queryClient);
    },
  });
};
